/**
 * FIXME move to a shared package
 * Copied from https://github.com/Source-Digital/experience-engine/blob/f1414a0be3a36df93048cabb9c685160a4a873bf/front/src/components/EntertainmentPlus/things/SmartBlockList.vue#L107-L114
 */

import { ActivationTemplate } from 'sd-types/models/activation'
import { upperFirst } from 'lodash-es'
import importExternalComponent from './import-external-component.ts'
import { ComputedRef, computed, unref } from 'vue-demi'
import { computedEager, type MaybeRef } from '@vueuse/core'

export function importSmartblockRef (dataRef: MaybeRef<ActivationTemplate & { moduleName?: string, moduleVersion?: string }>, options: { smartblockVersion: string, smartblockBaseUrl?: string }): ComputedRef<() => Promise<any>> {
  // Use eager so that module urls are computed ahead of time and we do not get flickering effect
  const component = computedEager(() => {
    const data = unref(dataRef)
    const baseURL = options.smartblockBaseUrl ?? 'https://cdn.sourcesync.io/smartblocks' // FIXME use env
    const moduleName = `${data.moduleName ?? 'source-digital~SmartBlock' + upperFirst(data.name)}@${data.moduleVersion ?? (options.smartblockVersion)}`
    const componentUrl = `${baseURL}/${moduleName}.umd.min.js`
    return { url: componentUrl, name: moduleName }
  })
  return computed(() => async () => await importExternalComponent(component.value.url, component.value.name))
}
